import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { INotesInfo } from '../models/CustomerModel';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { GeneralService } from 'src/app/services/general.service';
import { ICountry, IGetPermissionMandatoryField, ListOfProperty } from '../interface';
import { DatePipe } from '@angular/common';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { ECallScriptForms } from '../enum';
import { CommonMethodService } from 'src/app/Shared/common-method.service';

@Component({
    selector: 'app-notes-shared',
    templateUrl: 'notes-shared.component.html',
    styleUrls: ['notes-shared.component.scss'],
    standalone: false
})
export class NotesSharedComponent implements OnInit {
    @Input() ExistingTenantDetails;
    @Input() addressInfo;
    @Input() section;
    @Input() callScriptFields = [];
    @Output() emitSaveNotesCallScript = new EventEmitter();
    @Output() emitChangedScript = new EventEmitter();
    @Input() unitDetails;
    @Input() quickProspectContactInfo;
    notesDirty: boolean = false;
    bold: boolean = false;
    @Input() internalNotes: string;
    @Input() customerNotes: string;
    @Input() confirmNumber: number;
    @Input() keepActiveDate;
    @Input() tenantId: number;
    @Input() facId: number;
    @Input() requestOrigin: number;
    @Input() prioritynote: boolean = false;
    @Input() isQuickStart: boolean = false;
    @Input() isQuickInqRes: boolean = false;
    @Input() quickStartToday;
    @Output() emitCancelNotes = new EventEmitter();
    @Output() emitSaveNotes = new EventEmitter();
    @ViewChild('sharedNotesGrid', { static: false }) public sharedNotesGrid: GridComponent;
    @ViewChild("tooltip", { static: false }) public tooltip: TooltipComponent;
    filterSettings;
    notesResponse: any[] = [];
    notesData: any[] = [];
    notesGridData: any[] = [];
    customAttri: object;
    mandatoryFields: ListOfProperty[];
    componentName: string = '';
    customerNoteField: boolean;
    internalNoteField: boolean;
    priorityNoteField: boolean;
    Existingtenant: boolean = false;
    today: any;
    textareaColor = 'black';
    TenantName: string;
    Phone: any;
    EmailID: any;
    Address: any;
    City: any;
    CountryCode: any;
    unitTypeCode: any;
    countryList: ICountry[];
    constructor(private prospectService: ProspectService,
        public generalService: GeneralService,
        private facOpsDataService: FacOpsDataService,
        private commonMethod: CommonMethodService) { }

    ngOnInit() {
        this.bold = this.generalService.prospectPriorityNotes;
        this.filterSettings = { mode: 'Immediate', immediateModeDelay: '800' };
        this.customAttri = { 'class': 'customcss' };
        this.setMandatoryField(129); // Common for mandatory field for prospect, reservation and rental 
        if (this.requestOrigin == 1) { // Prospect
            this.getInqNote();
        } else if (this.requestOrigin == 2) { // Reservation
            this.getReservNote();
        } else if (this.requestOrigin == 3) { // Rental
            this.getRentNote();
        } else {
            this.getNotes(this.tenantId);
        }
        this.getCountries()
        const datepipe: DatePipe = new DatePipe('en');
        const date = new Date();
        this.today = datepipe.transform(new Date(), 'MM/dd/yyyy');
        if (this.isQuickStart && this.quickStartToday) {
            this.today = this.quickStartToday;
        }
        this.textareaColor = 'black';

        this.facOpsDataService.scriptIndex$.subscribe(({ section, index }) => {
            if (section !== this.section || this.facOpsDataService.onPageOpen) {
                return;
            }
            this.onScriptChange();
        });
        if (this.isQuickStart) {
            this.Existingtenant =   this.ExistingTenantDetails ? true : false;           
            this.unitTypeCode = this.unitDetails?.UnitTypeCode?this.unitDetails.UnitTypeCode : this.ExistingTenantDetails.UnitSize;
            const contactInfo = this.quickProspectContactInfo ?? '';
            let { FirstName, MiddleName, LastName } = contactInfo;
            let Nameformat = this.unitDetails.MiscellaneousSettings.TenantNameFormat;
            const middleName = MiddleName ?? this.facOpsDataService.contactInfo?.MiddleName ?? '';
            let displayName = this.commonMethod.getDispayName(FirstName, middleName, LastName, Nameformat);
            this.TenantName = displayName ?? '',
                this.Phone = contactInfo.Phone ?? '',
                this.EmailID = contactInfo.Email ?? '',
                this.Address = this.addressInfo?.Address? this.addressInfo.Address : this.ExistingTenantDetails?.Address? this.ExistingTenantDetails.Address :'',
                this.City =this.addressInfo?.City? this.addressInfo.City : this.ExistingTenantDetails?.City? this.ExistingTenantDetails.City :'',
                this.CountryCode = contactInfo.CountryId ? contactInfo.CountryId : this.ExistingTenantDetails.CellPhoneCountryId?this.ExistingTenantDetails.CellPhoneCountryId :  ''
        }
        else {
            const contactInfo = this.facOpsDataService.contactInfo ?? '';
            let { FirstName, MiddleName, LastName } = contactInfo;
            let Nameformat = this.unitDetails.MiscellaneousSettings.TenantNameFormat 
            let displayName = this.commonMethod.getDispayName(FirstName, MiddleName, LastName, Nameformat);
            this.unitTypeCode = this.unitDetails?.UnitTypeCode??this.unitDetails.UnitTypeCode
            this.TenantName = displayName ?? '',
            this.Phone = contactInfo.BusinessAccount ? (contactInfo.CompanyPhone ? contactInfo.CompanyPhone : '') : (contactInfo.CellPhoneNumber ? contactInfo.CellPhoneNumber : '');
            this.EmailID = contactInfo.BusinessAccount ? (contactInfo.CompanyEmail ? contactInfo.CompanyEmail : '') : (contactInfo.Email ? contactInfo.Email : '');
            this.Address = contactInfo.BusinessAccount ? (contactInfo.CompanyAddress ? contactInfo.CompanyAddress : '') : (contactInfo.Address ? contactInfo.Address : '');
            this.City = contactInfo.BusinessAccount ? (contactInfo.CompanyCity ? contactInfo.CompanyCity : '') : (contactInfo.City ? contactInfo.City : '');
            this.CountryCode = contactInfo.CellPhoneCountryId ?? ''
        }

    }

  getCountries() {
    this.generalService.getCountries().subscribe((response: ICountry[]) => {
      this.countryList = response;
      if(response){
        this.CountryCode = this.CountryCode != ''? this.countryList.find(x => x.Id == this.CountryCode).DialInCode:'';
      }
    });
  }

    dataBound(args) {
        Object.assign((<any>this.sharedNotesGrid.filterModule).filterOperators, { startsWith: 'contains' });
    }

    getNotes(id: number) {
        this.prospectService.getAllNotes(id).subscribe((response: INotesInfo[]) => {
            this.notesResponse = response;
            if (this.confirmNumber !== 0 && this.notesResponse.length !== 0) {
                this.notesResponse = this.notesResponse.filter((ele) => ele.InquiryNumber === this.confirmNumber ||
                    ele.ReservationNumber === this.confirmNumber);
            }
            this.notesData = [];
            this.notesResponse.map((ele) => {
                const obj = {
                    NotesDate: ele.NotesDate.replace('Z', ''),
                    Creator: ele.Creator,
                    Type: (ele.CustomerNotes === true) ? 'Customer' : 'Internal',
                    Notes: ele.Text
                };
                this.notesData.push(obj);
            });
            this.notesGridData = this.notesData;
        });
    }

    getInqNote() {
        this.prospectService.getInqNotes(this.confirmNumber, this.facId).subscribe((response: INotesInfo[]) => {
            this.notesResponse = response;
            if (this.confirmNumber !== 0 && this.notesResponse.length !== 0) {
                this.notesResponse = this.notesResponse.filter((ele) => ele.InquiryNumber === this.confirmNumber ||
                    ele.ReservationNumber === this.confirmNumber);
            }
            this.notesData = [];
            this.notesResponse.map((ele) => {
                const obj = {
                    NotesDate: ele.NotesDate.replace('Z', ''),
                    Creator: ele.Creator,
                    Type: (ele.CustomerNotes === true) ? 'Customer' : ((ele.PriorityNote === true) ? 'Priority' : 'Internal'),
                    Notes: ele.Text
                };
                this.notesData.push(obj);
            });
            this.notesGridData = this.notesData;
        });
    }

    getRentNote() {
        this.prospectService.getRentNotes(this.confirmNumber, this.facId).subscribe((response: INotesInfo[]) => {
            this.notesResponse = response;
            if (this.confirmNumber !== 0 && this.notesResponse.length !== 0) {
                this.notesResponse = this.notesResponse.filter((ele) => ele.InquiryNumber === this.confirmNumber ||
                    ele.ReservationNumber === this.confirmNumber);
            }
            this.notesData = [];
            this.notesResponse.map((ele) => {
                const obj = {
                    NotesDate: ele.NotesDate ? ele.NotesDate.replace('Z', '') : '',
                    Creator: ele.Creator,
                    Type: (ele.CustomerNotes === true) ? 'Customer' : ((ele.PriorityNote === true) ? 'Priority' : 'Internal'),
                    Notes: ele.Text
                };
                this.notesData.push(obj);
            });
            this.notesGridData = this.notesData;
        });
    }

    getReservNote() {
        this.prospectService.getResrvNotes(this.confirmNumber, this.facId).subscribe((response: INotesInfo[]) => {
            this.notesResponse = response;
            if (this.confirmNumber !== 0 && this.notesResponse.length !== 0) {
                this.notesResponse = this.notesResponse.filter((ele) => ele.InquiryNumber === this.confirmNumber ||
                    ele.ReservationNumber === this.confirmNumber);
            }
            this.notesData = [];
            this.notesResponse.map((ele) => {
                const obj = {
                    NotesDate: ele.NotesDate.replace('Z', ''),
                    Creator: ele.Creator,
                    Type: (ele.CustomerNotes === true) ? 'Customer' : ((ele.PriorityNote === true) ? 'Priority' : 'Internal'),
                    Notes: ele.Text
                };
                this.notesData.push(obj);
            });
            this.notesGridData = this.notesData;
        });
    }

    setNotesDirty(data) {
        this.notesDirty = true;
    }

    onNotesCancel() {
        this.emitCancelNotes.emit(this.notesDirty);
        this.textareaColor = 'black';
    }

    changePriority(eve) {
        if (eve.target.checked) {
            this.prioritynote = true;
            this.bold = true;
            this.textareaColor = 'red';
            this.generalService.prospectPriorityNotes = true;
        }
        else {
            this.prioritynote = false;
            this.bold = false;
            this.textareaColor = 'black';
            this.generalService.prospectPriorityNotes = false;
            this.keepActiveDate = null;
        }
    }
    savenotes() {
        this.emitSaveNotes.emit({ CustomerNotes: this.customerNotes, InternalNotes: this.internalNotes, PriorityNote: this.prioritynote, KeepActiveDate: this.keepActiveDate });
    }

    mouseover(args) {
        if (args.target.classList.contains('customcss') && args.target.innerText) {
            this.tooltip.content = args.target.innerText;
        } else if (args.target.classList.contains('customcss') && !args.target.innerText) {
            this.tooltip.content = ' ';
        }
    }

    setMandatoryField(formId: number) {
        this.generalService.GetMandatoryFieldsById(null, formId)
            .subscribe((response: IGetPermissionMandatoryField) => {
                this.customerNoteField = response.Form.ListOfProperties.find(o => o.Name == 'customerNotes').Required;
                this.priorityNoteField = response.Form.ListOfProperties.find(o => o.Name == 'prioritynote').Required;
                this.internalNoteField = response.Form.ListOfProperties.find(o => o.Name == 'internalNotes').Required;
            });
    }

    disableSave() {
        if ((this.internalNoteField || this.priorityNoteField) && this.internalNotes.trim() == '') {
            return true;
        } else if (this.customerNoteField && this.customerNotes.trim() == '') {
            return true;
        } else {
            return false;
        }
    }

    onScriptChange() {
        let script = this.facOpsDataService.getScript(this.section);
        if (!script || !script.FormId || script.FormId == ECallScriptForms['Prospect/Reservation/Rental: Notes']
            || (script.firstTimeCalled && !script.buttonNavigate)) {
            return;
        }
        script.firstTimeCalled = true;
        if (!this.disableSave()) {
            this.emitSaveNotesCallScript.emit({ CustomerNotes: this.customerNotes, InternalNotes: this.internalNotes, PriorityNote: this.prioritynote, KeepActiveDate: this.keepActiveDate });
        }
        this.emitChangedScript.emit(script);
    }
}
